<template>
  <info-header-card :icon="staff.icon()" :header="header" :rows="rows" />
</template>

<script>
import InfoHeaderCard from "@/components/shared/InfoHeaderCard";
import StaffModel from "@/models/lab/StaffModel";

export default {
  name: "StaffCard",
  components: {
    InfoHeaderCard
  },
  props: {
    staff: {
      type: Object,
      default: () => new StaffModel()
    }
  },
  computed: {
    header() {
      return this.staff.formatName();
    },
    rows() {
      const { title, email, laboratories, phone_number, work_groups } = this.staff;
      return [
        {
          label: "Title",
          value: title
        },
        {
          label: "Email",
          value: email
        },
        {
          label: "Phone",
          value: phone_number
        },
        {
          label: "Laboratories",
          value: laboratories.length
            ? laboratories.map(({ name }) => name).join(", ")
            : null
        },
        {
          label: "Work Groups",
          value: work_groups.length
            ? work_groups.map(({ name }) => name).join(", ")
            : null
        }
      ];
    }
  }
};
</script>
